module.exports = __webpack_public_path__ + "static/media/logo_ciudadanos.2d347190.svg";